import React from 'react';
import ChatImg from '../../../assets/img/chat.png';

export default function InstructionsText() {
  return (
    <div className="message-not-active-chat">
      <div className="message-not-active-chat__container-icon">
        <img className="message-not-active-chat__icon" src={ChatImg} alt="" />
      </div>
      <p className="message-not-active-chat__label">You {`don't`} have an active conversation</p>
      <p className="message-not-active-chat__label">
        To start a new conversation click on + button
      </p>
    </div>
  );
}
